import * as React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { isUnauthorizedError } from "@shared/lib/errors";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Favor SWR for UX: keep data fresh in the background
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (isUnauthorizedError(error)) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: { retry: 0 },
  },
});

export function QueryProvider({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
